/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import cn from '../../utils/cn';

function LibModal({ children, title, subTitle, setOpen, className }) {
    // outside click
    // useEffect(() => {
    //     const handleClickOutside = (e) => {
    //         if (e.target.classList.contains('lib-modal')) {
    //             setOpen(null);
    //         }
    //     };
    //     document.addEventListener('click', handleClickOutside);
    //     return () => document.removeEventListener('click', handleClickOutside);
    // }, [setOpen]);

    // add root overflow hidden

    // if press esc close modal
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                setOpen(null);
            }
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [setOpen]);

    useEffect(() => {
        document.getElementById('root').style.overflow = 'hidden';
        return () => {
            document.getElementById('root').style.overflow = 'unset';
        };
    }, []);
    return (
        <div
            className="lib-modal fixed bg-primary/50 top-0 left-0 px-4 w-full h-full flex flex-col justify-center items-center z-50"
            onClick={(ev) => ev.stopPropagation()}
        >
            <div
                className={cn(
                    'w-full sm:w-[500px] min-w-min min-h-[100px] lg:min-h-[150px] overflow-hidden bg-white rounded-2xl lg:rounded-[20px] relative my-5',
                    className
                )}
            >
                {/* lib modal header */}
                <div className="lib-modal__header border-b border-primary-100 select-none w-full flex flex-row justify-between items-center p-3 py-2 lg:p-4 pl-3 lg:pl-6 bg-white absolute top-0 left-0 z-50">
                    <div>
                        <h1 className="font-medium text-base lg:text-xl text-primary capitalize">
                            {title}
                        </h1>
                        <p className="font-normal text-xs lg:text-sm text-primary-700">
                            {subTitle}
                        </p>
                    </div>
                    <div
                        onClick={() => setOpen(null)}
                        tabIndex={-1}
                        role="button"
                        className="w-5 h-5 p-1 lg:w-[26px] lg:h-[26px] text-[#F50303] hover:text-white transition-colors duration-200 hover:bg-[#F50303] flex items-center justify-center cursor-pointer rounded-full border border-[#FF1B28]/10"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                        >
                            <path
                                d="M7.24326 5.99893L10.8841 2.35814C11.0506 2.1926 11.1426 1.97124 11.1426 1.73616C11.1426 1.50108 11.0506 1.28069 10.8841 1.11417C10.553 0.782124 9.97313 0.780165 9.6401 1.11417L5.9993 4.75497L2.3585 1.11417C2.01568 0.77135 1.45737 0.77135 1.11454 1.11417C0.771717 1.457 0.771717 2.01433 1.11454 2.35814L4.75534 5.99893L1.11454 9.63973C0.948027 9.80624 0.856934 10.0276 0.856934 10.2617C0.856934 10.4968 0.948027 10.7182 1.11454 10.8837C1.44757 11.2177 2.02841 11.2157 2.3585 10.8837L5.9993 7.2429L9.6401 10.8837C9.80661 11.0502 10.028 11.1423 10.2621 11.1423C10.4972 11.1423 10.7195 11.0502 10.8841 10.8837C11.0506 10.7182 11.1426 10.4968 11.1426 10.2627C11.1426 10.0286 11.0506 9.80624 10.8841 9.63973L7.24326 5.99893Z"
                                fill="currentColor"
                            />
                        </svg>
                    </div>
                </div>
                {/* Modal Body */}
                <div className="lib-modal__body px-3 lg:px-5 py-3 overflow-y-auto pt-12 lg:pt-18 custom-scrollbar h-full scroll-smooth">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default LibModal;
